<template>
    <div style="width: 100%;height: 20px;display: flex;">
        <div style="width: 25%;height: 100%;background-color: #000000;"></div>
        <div style="width: 25%;height: 100%;background-color: #ab050f;"></div>
        <div style="width: 25%;height: 100%;background-color: #ffce00;"></div>
        <div style="width: 25%;height: 100%;background-color: #c0c0c0;"></div>
    </div>
</template>

<script>
    export default {
        name: "ColorDivider"
    };
</script>

<style scoped>

</style>